/**
 * Client ID management for anonymous cart telemetry.
 *
 * Option A Design: Stateless anonymous carts
 * - Generate cryptographically random UUID
 * - Store in localStorage (no cookies = no consent needed)
 * - Used to link cart snapshots across sessions
 * - Linked to user account on login or checkout
 */

const CLIENT_ID_KEY = 'ff_client_id';

/**
 * Get or create client UUID for telemetry tracking.
 * @returns {string} Client UUID
 */
export const getOrCreateClientId = () => {
  let clientId = localStorage.getItem(CLIENT_ID_KEY);

  if (!clientId) {
    // Generate cryptographically random UUID
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      clientId = crypto.randomUUID();
    } else {
      // Fallback for older browsers
      clientId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    localStorage.setItem(CLIENT_ID_KEY, clientId);
    console.log('[CLIENT_ID] Generated new client UUID:', clientId);
  }

  return clientId;
};

/**
 * Clear client ID (for testing or user request).
 */
export const clearClientId = () => {
  localStorage.removeItem(CLIENT_ID_KEY);
  console.log('[CLIENT_ID] Cleared client UUID');
};

/**
 * Get existing client ID without creating one.
 * @returns {string|null} Client UUID or null if not set
 */
export const getClientId = () => {
  return localStorage.getItem(CLIENT_ID_KEY);
};
